import React from 'react'
import {
  DrawingToolsContainer,
  DrawingToolsFAB,
  DrawingToolsPanel,
  DrawingToolButton,
  DrawToolsDivider,
} from './DrawingTools.styles'
import { DrawingToolsProps, DrawingToolOption } from './DrawingTools.types'

const defaultTools: DrawingToolOption[] = [
  {
    id: 'line',
    label: 'Draw Line',
    icon: (
      <svg className="icon" viewBox="0 0 24 24">
        <path d="M4 20L20 4" />
      </svg>
    ),
  },
  {
    id: 'polygon',
    label: 'Draw Polygon',
    icon: (
      <svg className="icon" viewBox="0 0 24 24">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
      </svg>
    ),
  },
  {
    id: '3d',
    label: '3D Mode',
    icon: (
      <svg className="icon" viewBox="0 0 24 24">
        <path d="M12 2L2 9v11l10 7 10-7V9L12 2z" />
        <path d="M12 22V12" />
        <path d="M12 12L2 9" />
        <path d="M12 12l10-3" />
      </svg>
    ),
  },
]

export const DrawingTools: React.FC<DrawingToolsProps> = ({
  open,
  onToggle,
  activeTool = 'none',
  onToolSelect,
  onDeleteAll,
  tools = defaultTools,
  showDeleteAll = true,
  deleteButtonLabel = 'Delete All',
  className,
  fabPosition,
  zIndex,
  fabContent = (
    <svg className="icon" viewBox="0 0 24 24">
      <path
        d="M13.5 6.5L17.5 10.5M4 20h4L18.5 9.5a2.828 2.828 0 10-4-4L4 16v4z"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
      />
    </svg>
  ),
  fabTooltip = 'Drawing Tools',
}) => {
  const handleToolSelect = (toolId: DrawingToolOption['id']) => {
    if (toolId === activeTool) {
      onToolSelect?.('none')
    } else {
      onToolSelect?.(toolId)
    }
  }

  return (
    <DrawingToolsContainer className={className}>
      <DrawingToolsFAB
        $active={open}
        onClick={onToggle}
        $position={fabPosition}
        $zIndex={zIndex}
        title={fabTooltip}
        aria-label={fabTooltip}
      >
        {fabContent}
      </DrawingToolsFAB>
      <DrawingToolsPanel $active={open}>
        {tools.map((tool) => (
          <DrawingToolButton
            key={tool.id}
            $active={activeTool === tool.id}
            $disabled={tool.disabled}
            onClick={() => handleToolSelect(tool.id)}
            disabled={tool.disabled}
          >
            {tool.icon}
            <span>{tool.label}</span>
          </DrawingToolButton>
        ))}
        {showDeleteAll && onDeleteAll && (
          <>
            <DrawToolsDivider />
            <DrawingToolButton $variant="delete" onClick={onDeleteAll}>
              <svg className="icon" viewBox="0 0 24 24">
                <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span>{deleteButtonLabel}</span>
            </DrawingToolButton>
          </>
        )}
      </DrawingToolsPanel>
    </DrawingToolsContainer>
  )
}
